import { debounce } from '../../domain/utils/debounce.js';

const listeners = [];
let initialized = false;

const getWindowSize = () => ({
  width: window.innerWidth,
  height: window.innerHeight
});

let oldWindowSize = getWindowSize();

const handleEvent = () => {
  const newWindowSize = getWindowSize();
  if (
    newWindowSize.width !== oldWindowSize.width ||
    newWindowSize.height !== oldWindowSize.height
  ) {
    listeners.forEach(listener => listener(newWindowSize, oldWindowSize));
    oldWindowSize = newWindowSize;
  }
};

export const windowSizeListener = listener => {
  if (!initialized) {
    initialized = true;
    window.addEventListener('resize', debounce(handleEvent), {
      passive: true
    });
  }
  listeners.push(listener);
};
